import { components } from '@kurtosys/ksys-app-components';
import { common } from '@kurtosys/ksys-app-template';
import { IManifest } from '@kurtosys/types/appsManager/index.js';
import { action, computed, makeObservable } from 'mobx';

import { TStoreContext } from '../../../models/index.js';
import { AppStore } from '../../App/stores/AppStore.js';
import { FilterPropertyStore } from '../../App/stores/FilterPropertyStore.js';
import { InputStoreBase } from '../../shared/InputStoreBase.js';
import { IClearAllFiltersComponentProps } from '../models/IClearAllFiltersComponentProps.js';
import { IClearAllFiltersConfiguration } from '../models/IClearAllFiltersConfiguration.js';
import { IClearAllFiltersOptions } from '../models/IClearAllFiltersOptions.js';
type IButtonProps = components.base.Button.models.IButtonProps;

export class ClearAllFiltersStore extends InputStoreBase<
	IClearAllFiltersOptions,
	IClearAllFiltersComponentProps,
	string
> {
	static componentKey = 'clearAllFilters' as const;

	appStore: AppStore;

	constructor(
		storeContext: TStoreContext,
		manifest: IManifest,
		inputKey: string,
		options: IClearAllFiltersOptions,
		componentProps: IClearAllFiltersComponentProps,
	) {
		super(storeContext, manifest, inputKey, options, componentProps);
		this.appStore = this.storeContext.get<AppStore>('appStore');
		makeObservable(this);
	}

	@computed
	get filterPropertyStore(): FilterPropertyStore {
		return this.storeContext.get<FilterPropertyStore>('filterPropertyStore');
	}

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	initializeItems = async () => {};

	initializeValue = (): string => {
		return '';
	};

	@computed
	get hasData(): boolean {
		return true;
	}

	@computed
	get configuration(): IClearAllFiltersConfiguration | undefined {
		if (this.appStore) {
			return this.appStore.getComponentConfiguration(ClearAllFiltersStore.componentKey);
		}
	}

	@computed
	get buttonProps(): IButtonProps {
		const componentProps = this.componentProps;
		const buttonProps: IButtonProps = this.mergeQueriesAndProps(componentProps) || {
			text: 'Clear All Filters',
		};
		buttonProps.onClick = this.ClearAllFilters;
		buttonProps.text = common.commonUtils.replacePlaceholders({
			text: buttonProps.text,
			values: {
				activeFilterCount: this.filterPropertyStore.selectedFilters,
			},
		});

		if (this.filterPropertyStore.selectedFilters === 0) {
			buttonProps.disabled = true;
		}
		return buttonProps;
	}

	@action
	ClearAllFilters = () => {
		this.filterPropertyStore.clearAllFilters();
	};

	@action
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	async initialize(): Promise<void> {}
}
